module.exports = __webpack_public_path__ + "static/media/signup-icon-03.d351e3a6.svg";